import moment from 'moment';

export const months = [
	moment().subtract(1, 'month').format('MMMM_YYYY').toUpperCase(),
	moment().subtract(2, 'month').format('MMMM_YYYY').toUpperCase(),
	moment().subtract(3, 'month').format('MMMM_YYYY').toUpperCase(),
];
